import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from './Badge';
export const DangerBadge = (props) => {
    return _jsx(Badge, { type: 'danger', ...props });
};
//# sourceMappingURL=DangerBadge.js.map